import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

export const Confirm = ({ open, title, body, action, onConfirm, onCancel, testid }) => (
  <AlertDialog open={open} onOpenChange={(o) => !o && onCancel()}>
    <AlertDialogContent className="bg-[#111827] border-slate-700 text-slate-100" data-testid={testid}>
      <AlertDialogHeader>
        <AlertDialogTitle className="font-heading">{title}</AlertDialogTitle>
        <AlertDialogDescription className="text-slate-400">{body}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid={`${testid}-cancel`} className="bg-transparent border-slate-700 text-slate-300 hover:bg-slate-800 hover:text-slate-100">Cancel</AlertDialogCancel>
        <AlertDialogAction data-testid={`${testid}-confirm`} onClick={onConfirm} className="bg-rose-500 text-white hover:bg-rose-400">{action}</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
